import React from 'react';
import { Formik, Form, Field, CccisdInput, CccisdWysiwyg } from 'cccisd-formik';
import axios from 'cccisd-axios';
import style from './style.css';
import notification from 'cccisd-notification';

const Boilerplate = window.cccisd.boilerplate;
const AppDefs = window.cccisd.appDefs;

const MessageForm = props => {
    const template = AppDefs.app?.siteContent?.contactEmail;
    // const linkButtonString = `<strong>${props.label}:</strong><br/><a href=${props.link} target="_blank" rel="noopener noreferrer" style="cursor: pointer;outline: 0;color: #fff;background-color: #0d6efd;border-color: #0d6efd; display: inline-block; font-weight: 400; line-height: 1.5;text-align: center;border: 1px solid transparent;padding: 6px 12px;font-size: 16px;border-radius: .25rem;"> Take Survey </a>`;

    const submit = async values => {
        try {
            const response = await axios.post(Boilerplate.route('api.assessment.sendNotification'), {
                recipient: values.recipient,
                sendMethod: 'email',
                messageInfo: {
                    subject: values.subject,
                    body: values.body,
                    actionUrl: props.link,
                },
                messageLogData: {
                    pawn_id: props.sessionDeploymentInfo.pawnId,
                    deployment_id: props.sessionDeploymentInfo.deploymentId,
                    action: props.action ?? 'assessment_plan_notification',
                },
            });
            if (response && response.status === 200) {
                notification({ message: 'Email has been sent.', type: 'success' });
                props.messageSuccess();
                props.closeModal();
            }
        } catch (e) {
            notification({ message: 'An error occured sending email!', type: 'danger' });
            console.error(e);
        }
    };

    const validate = values => {
        const errors = {};
        if (!values.subject) {
            errors.subject = 'Email subject is required';
        }
        if (!values.body) {
            errors.body = 'Email body is required';
        }
        if (!values.recipient) {
            errors.recipient = 'Recipient is required';
        }
        return errors;
    };

    return (
        <div className={style.formRender}>
            <Formik
                initialValues={{
                    recipient: props.contact.fields.contactEmail,
                    subject: template?.subject ? template.subject : `${props.row.label} Assessment Plan`,
                    body: template?.body
                        ? template.body + `<strong>${props.label}:</strong>`
                        : `Assessment ${props.row.label} is available to take! <br/><br/> Click the button below to start <br/><br/>`,
                }}
                validate={validate}
                onSubmit={submit}
                render={() => (
                    <Form>
                        <Field name="recipient" component={CccisdInput} label="Recipient" required />
                        <Field name="subject" component={CccisdInput} label="Email Subject" required />
                        <div className={style.body}>
                            <Field name="body" component={CccisdWysiwyg} label="Email Body" type="textarea" required />
                        </div>
                        Note: The assessment link and salutation will appear below the email body when it is sent.
                        <br />
                        <button className="btn btn-primary" type="submit" style={{ marginTop: '20px' }}>
                            Submit
                        </button>
                    </Form>
                )}
            />
        </div>
    );
};

export default MessageForm;
